import type {
  SchemaFieldListResponseDto,
  SaveSchemaFieldRequestDto,
  SchemaFieldDto,
  SchemaFieldExtraDto,
  SchemaFieldValueDto,
  SchemaFieldValueOption,
  SchemaFieldFormValues,
} from './types';
import type { ApiResponse, SchemaField } from '../../interfaces';

function fromApiFormat({ field_extra, field_type }: SchemaFieldDto): string | null {
  if (field_type === 'date') {
    return field_extra?.date_format || null;
  }

  if (field_type === 'datetime') {
    return field_extra?.datetime_format || null;
  }

  return null;
}

export function fromApiSchemaField(field: SchemaFieldDto): SchemaField {
  if (!field) return null;

  return {
    code: field.field_code,
    format: fromApiFormat(field),
    id: field.id,
    isArchived: field.is_archived,
    isDefault: field.is_default,
    name: field.field_name,
    schemaType: field.schema_type,
    type: field.field_type,
  };
}

export function fromApiSchemaFieldList(response: SchemaFieldListResponseDto): ApiResponse<SchemaField[]> {
  return { ...response, data: response.data.map(fromApiSchemaField) };
}

function toApiFieldExtra({ format, type }: SchemaFieldFormValues): SchemaFieldExtraDto {
  if (!format) {
    return {};
  }

  if (type === 'date') {
    return { date_format: format };
  }

  if (type === 'datetime') {
    return { datetime_format: format };
  }

  return {};
}

export function toApiSaveSchemaField(values: SchemaFieldFormValues): SaveSchemaFieldRequestDto {
  return {
    ...(values.id !== undefined ? { id: values.id } : {}),
    ...(values.isArchived !== undefined ? { is_archived: values.isArchived } : {}),
    ...(values.isDefault !== undefined ? { is_default: values.isDefault } : {}),
    field_code: values.code,
    field_extra: toApiFieldExtra(values),
    field_name: values.name,
    field_type: values.type,
    schema_type: values.schemaType,
  };
}

export function fromApiSchemaFieldValues(
  response: ApiResponse<SchemaFieldValueDto[]>,
): ApiResponse<SchemaFieldValueOption[]> {
  return {
    ...response,
    data: response.data.map((field) => ({
      id: field.id,
      name: field.name,
      tagGroupId: field.tag_group_id,
      tagGroupName: field.tag_group_name,
      schemaFieldId: field.schema_field_id || field.schemaFieldId || field.schema_field?.id || field.schemaField?.id,
    })),
  };
}
